import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getAllPermissions } from '../../services'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'
import { OperatorGroupPermission } from '@/schema'

export default function useQueryGetAllPermission(
	props?: UseBaseQueryOptions<OperatorGroupPermission[]>,
) {
	return useQuery({
		queryKey: [OperatorQueryKeys.GetAllPermissions],
		queryFn: () => getAllPermissions(),
		...props,
	})
}
